import * as HTTP_REQUEST from "./api";
import { handleResponse } from "../utils/functions";

const LOGIN_USER = "/users/login";
const PATH_USERS = "/users/";
const GET_BY_ROLE = "/users/role/";
const UPDATE_PASSWORD = "/users/password/";

export const login = async (body) => {
  const response = await HTTP_REQUEST.post(LOGIN_USER, body);
  return handleResponse(response);
};

export const getAll = async () => {
  const response = await HTTP_REQUEST.get(PATH_USERS);
  return handleResponse(response);
};

export const getAboutRole = async (role) => {
  const response = await HTTP_REQUEST.get(GET_BY_ROLE, role);
  return handleResponse(response);
};

export const addOne = async (body) => {
  const response = await HTTP_REQUEST.post(PATH_USERS, body);
  return handleResponse(response);
};

export const deleteOne = async (userId) => {
  const response = await HTTP_REQUEST.delt(PATH_USERS, userId);
  return handleResponse(response);
};

export const updateOne = async (body, userId) => {
  const response = await HTTP_REQUEST.put(PATH_USERS, body, userId);
  return handleResponse(response);
};

export const updatePass = async (body, userId) => {
  const response = await HTTP_REQUEST.put(UPDATE_PASSWORD, body, userId);
  return handleResponse(response);
};
